module.exports = __webpack_public_path__ + "img/vipPropFull.e4e9e689.png";